import ExclamationCircledFill from "./exclamation-circled-fill.svg";

export const YellowIcons = {
  ExclamationCircledFill,
};
